import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@brunata-angular/util';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Clipboard} from '@angular/cdk/clipboard';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-api-token-created-modal',
    standalone: true,
    imports: [TranslatePipe, ReactiveFormsModule],
    templateUrl: './api-token-created-modal.component.html',
    styleUrl: './api-token-created-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiTokenCreatedModalComponent {
    @Input() token = '';
    constructor(
        public activeModal: NgbActiveModal,
        public clipboard: Clipboard,
        private translateService: TranslateService,
        private toastrService: ToastrService,
    ) {}

    copy(): void {
        this.clipboard.copy(this.token);
        this.toastrService.success(this.translateService.translate('utilities_Token_copied'));
    }
}
